module.exports = __webpack_public_path__ + "images/category_lp/common/arrow-down_99014da983c5e181222a9bc8e8dd18a8.png";